var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-container',{staticClass:"admin-view text-center pt-10"},[_c('div',[_c('v-btn',{staticClass:"white--text blue font-weight-bold",attrs:{"depressed":"","large":""},on:{"click":_vm.dumpLatestAppSettingsQueries}},[_vm._v(" Dump queries for latest in-app update (settings) ")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }